export const tiposVistoria = [
  "Inventário Inicial",
  "Vistoria Técnica",
  "Remedição",
  "Monitoramento Anual",
  "Monitoramento Semestral",
  "Pós-poda",
  "Pós-replantio",
  "Emergencial",
  "Compensação Ambiental",
  "UC / Área Verde",
];

export const statusVistoria = [
  "Rascunho",
  "Concluída",
  "Em Revisão",
  "Validada",
  "Reprovada",
  "Vencida",
  "Cancelada",
];

export const tipoVistoriaConfig: Record<string, { badge: string; icon: string }> = {
  "Inventário Inicial": { badge: "bg-accent-100 text-accent-700", icon: "ri-search-eye-line" },
  "Vistoria Técnica": { badge: "bg-primary-100 text-primary-700", icon: "ri-clipboard-line" },
  "Remedição": { badge: "bg-secondary-100 text-secondary-700", icon: "ri-ruler-line" },
  "Monitoramento Anual": { badge: "bg-primary-50 text-primary-600", icon: "ri-calendar-check-line" },
  "Monitoramento Semestral": { badge: "bg-accent-50 text-accent-600", icon: "ri-calendar-event-line" },
  "Pós-poda": { badge: "bg-warning-100 text-warning-700", icon: "ri-scissors-cut-line" },
  "Pós-replantio": { badge: "bg-caution-100 text-caution-700", icon: "ri-seedling-line" },
  Emergencial: { badge: "bg-danger-100 text-danger-700", icon: "ri-alert-line" },
  "Compensação Ambiental": { badge: "bg-primary-100 text-primary-700", icon: "ri-recycle-line" },
  "UC / Área Verde": { badge: "bg-accent-100 text-accent-700", icon: "ri-landscape-line" },
  Inventário: { badge: "bg-accent-100 text-accent-700", icon: "ri-search-eye-line" },
  Monitoramento: { badge: "bg-primary-50 text-primary-600", icon: "ri-calendar-check-line" },
  "Pós-manejo": { badge: "bg-warning-100 text-warning-700", icon: "ri-scissors-cut-line" },
  Supervisão: { badge: "bg-secondary-100 text-secondary-700", icon: "ri-eye-line" },
  Outro: { badge: "bg-background-100 text-foreground-500", icon: "ri-more-line" },
};

export const statusVistoriaConfig: Record<string, { badge: string; label: string }> = {
  Rascunho: { badge: "bg-background-100 text-foreground-500", label: "Rascunho" },
  Concluída: { badge: "bg-primary-100 text-primary-700", label: "Concluída" },
  "Em Revisão": { badge: "bg-warning-100 text-warning-700", label: "Em Revisão" },
  Validada: { badge: "bg-accent-100 text-accent-700", label: "Validada" },
  Reprovada: { badge: "bg-danger-100 text-danger-700", label: "Reprovada" },
  Vencida: { badge: "bg-danger-50 text-danger-600 border border-danger-300", label: "Vencida" },
  Cancelada: { badge: "bg-background-100 text-foreground-500", label: "Cancelada" },
};

export const estadoFitoVistoriaConfig: Record<string, { badge: string; label: string }> = {
  bom: { badge: "bg-primary-100 text-primary-700", label: "Bom" },
  BOM: { badge: "bg-primary-100 text-primary-700", label: "Bom" },
  regular: { badge: "bg-caution-100 text-caution-700", label: "Regular" },
  REGULAR: { badge: "bg-caution-100 text-caution-700", label: "Regular" },
  ruim: { badge: "bg-warning-100 text-warning-700", label: "Ruim" },
  RUIM: { badge: "bg-warning-100 text-warning-700", label: "Ruim" },
  critico: { badge: "bg-danger-100 text-danger-700", label: "Crítico" },
  CRITICO: { badge: "bg-danger-100 text-danger-700", label: "Crítico" },
  morto: { badge: "bg-background-100 text-foreground-500", label: "Morto" },
  MORTO: { badge: "bg-background-100 text-foreground-500", label: "Morto" },
};

export const riscoVistoriaConfig: Record<string, { badge: string; label: string }> = {
  baixo: { badge: "bg-primary-100 text-primary-700", label: "Baixo" },
  BAIXO: { badge: "bg-primary-100 text-primary-700", label: "Baixo" },
  medio: { badge: "bg-caution-100 text-caution-700", label: "Médio" },
  MEDIO: { badge: "bg-caution-100 text-caution-700", label: "Médio" },
  alto: { badge: "bg-warning-100 text-warning-700", label: "Alto" },
  ALTO: { badge: "bg-warning-100 text-warning-700", label: "Alto" },
  critico: { badge: "bg-danger-100 text-danger-700", label: "Crítico" },
  CRITICO: { badge: "bg-danger-100 text-danger-700", label: "Crítico" },
};
